import { default as indexpTGZQQbn6DMeta } from "/home/vsts/work/1/s/UI/mycim-app/pages/index.vue?macro=true";
import { default as loginQCEitAQbt3Meta } from "/home/vsts/work/1/s/UI/mycim-app/pages/login.vue?macro=true";
import { default as openTEriF2kXLBMeta } from "/home/vsts/work/1/s/UI/mycim-app/pages/open.vue?macro=true";
export default [
  {
    name: indexpTGZQQbn6DMeta?.name ?? "index___en",
    path: indexpTGZQQbn6DMeta?.path ?? "/en",
    children: [],
    meta: indexpTGZQQbn6DMeta || {},
    alias: indexpTGZQQbn6DMeta?.alias || [],
    redirect: indexpTGZQQbn6DMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexpTGZQQbn6DMeta?.name ?? "index___fr",
    path: indexpTGZQQbn6DMeta?.path ?? "/fr",
    children: [],
    meta: indexpTGZQQbn6DMeta || {},
    alias: indexpTGZQQbn6DMeta?.alias || [],
    redirect: indexpTGZQQbn6DMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexpTGZQQbn6DMeta?.name ?? "index___es",
    path: indexpTGZQQbn6DMeta?.path ?? "/es",
    children: [],
    meta: indexpTGZQQbn6DMeta || {},
    alias: indexpTGZQQbn6DMeta?.alias || [],
    redirect: indexpTGZQQbn6DMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexpTGZQQbn6DMeta?.name ?? "index___ru",
    path: indexpTGZQQbn6DMeta?.path ?? "/ru",
    children: [],
    meta: indexpTGZQQbn6DMeta || {},
    alias: indexpTGZQQbn6DMeta?.alias || [],
    redirect: indexpTGZQQbn6DMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexpTGZQQbn6DMeta?.name ?? "index___zh",
    path: indexpTGZQQbn6DMeta?.path ?? "/zh",
    children: [],
    meta: indexpTGZQQbn6DMeta || {},
    alias: indexpTGZQQbn6DMeta?.alias || [],
    redirect: indexpTGZQQbn6DMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginQCEitAQbt3Meta?.name ?? "login___en",
    path: loginQCEitAQbt3Meta?.path ?? "/en/login",
    children: [],
    meta: loginQCEitAQbt3Meta || {},
    alias: loginQCEitAQbt3Meta?.alias || [],
    redirect: loginQCEitAQbt3Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQCEitAQbt3Meta?.name ?? "login___fr",
    path: loginQCEitAQbt3Meta?.path ?? "/fr/login",
    children: [],
    meta: loginQCEitAQbt3Meta || {},
    alias: loginQCEitAQbt3Meta?.alias || [],
    redirect: loginQCEitAQbt3Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQCEitAQbt3Meta?.name ?? "login___es",
    path: loginQCEitAQbt3Meta?.path ?? "/es/login",
    children: [],
    meta: loginQCEitAQbt3Meta || {},
    alias: loginQCEitAQbt3Meta?.alias || [],
    redirect: loginQCEitAQbt3Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQCEitAQbt3Meta?.name ?? "login___ru",
    path: loginQCEitAQbt3Meta?.path ?? "/ru/login",
    children: [],
    meta: loginQCEitAQbt3Meta || {},
    alias: loginQCEitAQbt3Meta?.alias || [],
    redirect: loginQCEitAQbt3Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: loginQCEitAQbt3Meta?.name ?? "login___zh",
    path: loginQCEitAQbt3Meta?.path ?? "/zh/login",
    children: [],
    meta: loginQCEitAQbt3Meta || {},
    alias: loginQCEitAQbt3Meta?.alias || [],
    redirect: loginQCEitAQbt3Meta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/login.vue").then(m => m.default || m)
  },
  {
    name: openTEriF2kXLBMeta?.name ?? "open___en",
    path: openTEriF2kXLBMeta?.path ?? "/en/open",
    children: [],
    meta: openTEriF2kXLBMeta || {},
    alias: openTEriF2kXLBMeta?.alias || [],
    redirect: openTEriF2kXLBMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/open.vue").then(m => m.default || m)
  },
  {
    name: openTEriF2kXLBMeta?.name ?? "open___fr",
    path: openTEriF2kXLBMeta?.path ?? "/fr/open",
    children: [],
    meta: openTEriF2kXLBMeta || {},
    alias: openTEriF2kXLBMeta?.alias || [],
    redirect: openTEriF2kXLBMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/open.vue").then(m => m.default || m)
  },
  {
    name: openTEriF2kXLBMeta?.name ?? "open___es",
    path: openTEriF2kXLBMeta?.path ?? "/es/open",
    children: [],
    meta: openTEriF2kXLBMeta || {},
    alias: openTEriF2kXLBMeta?.alias || [],
    redirect: openTEriF2kXLBMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/open.vue").then(m => m.default || m)
  },
  {
    name: openTEriF2kXLBMeta?.name ?? "open___ru",
    path: openTEriF2kXLBMeta?.path ?? "/ru/open",
    children: [],
    meta: openTEriF2kXLBMeta || {},
    alias: openTEriF2kXLBMeta?.alias || [],
    redirect: openTEriF2kXLBMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/open.vue").then(m => m.default || m)
  },
  {
    name: openTEriF2kXLBMeta?.name ?? "open___zh",
    path: openTEriF2kXLBMeta?.path ?? "/zh/open",
    children: [],
    meta: openTEriF2kXLBMeta || {},
    alias: openTEriF2kXLBMeta?.alias || [],
    redirect: openTEriF2kXLBMeta?.redirect || undefined,
    component: () => import("/home/vsts/work/1/s/UI/mycim-app/pages/open.vue").then(m => m.default || m)
  }
]